import React from 'react';
import { useRouter } from 'next/router';
import { Box } from '@qga/roo-ui/components';

import Header from '@/components/Header';
import SiteFooter from '@/v2/components/ui/SiteFooter';

const SimpleLayout = ({ children }) => {
  const { pathname } = useRouter();
  const hasOffset = pathname?.includes('/checkout');

  return (
    <Box bg="greys.porcelain">
      <Header />
      {children}
      <SiteFooter withLogo hasOffset={hasOffset} />
    </Box>
  );
};

export default SimpleLayout;
